export const STAGE5_DIRECT_FREE_ENABLED = process.env.REACT_APP_STAGE5_DIRECT_FREE_ENABLED === "true";
export const STAGE5_DIRECT_FREE_URL = process.env.REACT_APP_STAGE5_DIRECT_FREE_URL
  || "https://us-central1-invitations778.cloudfunctions.net/manageStage5DirectFree";

export const callStage5DirectFree = async ({ action, idToken = "", payload = {} }) => {
  const response = await fetch(STAGE5_DIRECT_FREE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}) },
    body: JSON.stringify({ action, ...payload }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.code || "STAGE5_DIRECT_SIGNUP_FAILED");
    error.code = result.code || `HTTP_${response.status}`;
    throw error;
  }
  return result;
};
